export const CounsellingTypeList = [
    { id: "PER_SUBJECT", name: "PER_SUBJECT" },
    { id: "POST_ORDER", name: "POST_ORDER" },
    { id: "PRE_ORDER", name: "PRE_ORDER" },
    { id: "MENTORSHIP", name: "MENTORSHIP", filter: "id", value: "MENTORSHIP" }
]